module.exports = __webpack_public_path__ + "img/Group 4641_copy1.f2712fc6.png";